import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./typeAhead.html";
import { selectParams, WireStore } from '@oneappexchange/lwc-wired';
import { Routes } from '~/modules/routes';
import { selectTypeAhead, WireI18n } from '~/modules/stores/i18nStore';
import { recentItemStore, selectRecentItems } from '~/modules/stores/recentItemStore';
import { navigate, routerStore, selectUrl } from '~/modules/stores/routerStore';
import { searchTermSuggestionStore, selectSearchTermSuggestions } from '~/modules/stores/searchTermSuggestionStore';
import { debounce } from '~/modules/utilities/browser';
import { sanitizeText } from '~/modules/utilities/html_utilities';
var FocusDirection = /*#__PURE__*/function (FocusDirection) {
  FocusDirection[FocusDirection["Up"] = -1] = "Up";
  FocusDirection[FocusDirection["Down"] = 1] = "Down";
  return FocusDirection;
}(FocusDirection || {});
const debounceTimeout = 300;
class TypeAhead extends LightningElement {
  constructor(...args) {
    super(...args);
    this.keyword = '';
    this.userId = 'testuser';
    this.displayDrawer = false;
    this.maxSearchCharLimit = 512;
    this.searchTermSuggestions = [];
    this.recentItems = [];
    // @ts-expect-error * Automated Type Error Fix
    this.
    // @ts-expect-error * Automated Type Error Fix
    labels = void 0;
  }
  async setKeywordFromParamsAndUrl(info) {
    if (info.params && info.params.keywords && info.url.includes(Routes.SEARCH)) {
      const keyword = sanitizeText(info.params.keywords);
      this.keyword = keyword.trim().slice(0, this.maxSearchCharLimit);
    } else {
      this.keyword = '';
    }
    this.toggleDisplayDrawer(false);
    this.blurInput();
  }
  async setSearchResults(searchState) {
    if (searchState) {
      // @ts-expect-error * Automated Type Error Fix
      this.setSearchTermSuggestions(selectSearchTermSuggestions(searchState, this.keyword));
    }
  }
  async setRecentItemsResults(recentItemState) {
    if (recentItemState) {
      this.setRecentItems(selectRecentItems(recentItemState));
    }
  }

  // @ts-expect-error * Automated Type Error Fix
  handleTextInput(event) {
    if (this.isNewKeyword(event.target.value)) {
      this.doItemSearch(event.target.value, true);
      this.unfocusActiveElement();
    }
  }

  // @ts-expect-error * Automated Type Error Fix
  handleInputKeyUp(event) {
    if (event.key === 'Enter') {
      const focusedOption = this.getFocusedItem();
      if (focusedOption) {
        this.handleOptionSelected(focusedOption);
      } else {
        this.doSearch(this.keyword);
      }
    }
  }

  // @ts-expect-error * Automated Type Error Fix
  isNewKeyword(keyword) {
    return keyword !== this.keyword || !this.searchTermSuggestions?.length;
  }

  // @ts-expect-error * Automated Type Error Fix
  handleInputKeyDown(event) {
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      // Prevent the page from scrolling, when navigating options with arrow keys
      this.toggleDisplayDrawer(true);
      event.preventDefault();
      const suggestions = this.template.querySelectorAll('.list-option');
      if (suggestions.length) {
        const focusedElementIdx = this.getFocusedItemIndex(suggestions);
        if (event.key === 'ArrowDown') {
          this.moveFocus(focusedElementIdx, suggestions, 0, FocusDirection.Down);
        } else {
          this.moveFocus(focusedElementIdx, suggestions, suggestions.length - 1, FocusDirection.Up);
        }
      }
    }
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      this.unfocusActiveElement();
    }
    if (event.key === 'Escape') {
      this.toggleDisplayDrawer(false);
    }
  }
  getInputElement() {
    // @ts-expect-error * Automated Type Error Fix
    return this.template.querySelector('.bar-input');
  }

  // @ts-expect-error * Automated Type Error Fix
  handleOptionMouseOver(event) {
    const focusedElement = this.getFocusedItem();
    const nextElement = event.currentTarget;
    const inputElement = this.getInputElement();
    if (focusedElement) {
      this.unfocusElement(inputElement, focusedElement);
    }
    if (nextElement) {
      this.focusElement(inputElement, nextElement);
    }
  }

  // @ts-expect-error * Automated Type Error Fix
  handleBackdropMouseOver(_event) {
    this.unfocusActiveElement();
  }

  // @ts-expect-error * Automated Type Error Fix
  handleCloseKeyDown(event) {
    if (event.key === 'Enter') {
      this.handleCloseIconClick();
    }
  }

  // @ts-expect-error * Automated Type Error Fix
  handleContainerFocusOut(event) {
    const isFocusWithinTypeahead = event.relatedTarget && this.template.contains(event.relatedTarget);
    if (!isFocusWithinTypeahead) {
      this.toggleDisplayDrawer(false);
      this.blurInput();
    }
  }
  getFocusedItemIndex(suggestions) {
    return Array.from(suggestions).findIndex(s => s.classList.contains('active'));
  }
  getFocusedItem() {
    // @ts-expect-error * Automated Type Error Fix
    return this.template.querySelector('.list-option.active');
  }
  moveFocus(focusedElementIdx, suggestions, startPosition, direction) {
    const inputElement = this.getInputElement();
    const focusedElement = suggestions.item(focusedElementIdx);
    if (focusedElement) {
      const nextElement = suggestions.item(focusedElementIdx + direction);
      this.unfocusElement(inputElement, focusedElement);
      if (nextElement) {
        this.focusElement(inputElement, nextElement);
      }
    } else {
      const firstElement = suggestions.item(startPosition);
      this.focusElement(inputElement, firstElement);
    }
  }
  unfocusElement(inputElement, focusedElement) {
    focusedElement.classList.remove('active');
    focusedElement.setAttribute('aria-selected', 'false');
    inputElement.setAttribute('aria-activedescendant', '');
  }
  focusElement(inputElement, nextElement, shouldScroll = true) {
    nextElement.classList.add('active');
    nextElement.setAttribute('aria-selected', 'true');
    inputElement.setAttribute('aria-activedescendant', nextElement.id);
    if (shouldScroll) {
      nextElement.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'start'
      });
    }
  }
  unfocusActiveElement() {
    const inputElement = this.getInputElement();
    const focusedElement = this.getFocusedItem();
    if (inputElement && focusedElement) {
      this.unfocusElement(inputElement, focusedElement);
    }
  }

  // @ts-expect-error * Automated Type Error Fix
  doItemSearch(newKeyword, debounceRequired) {
    this.keyword = newKeyword;
    if (this.keywordPresent()) {
      if (debounceRequired) {
        this.debounceTimer = debounce(this, this.doSuggestionsSearch, [], this.debounceTimer, debounceTimeout);
      } else {
        this.doSuggestionsSearch();
      }
    } else {
      this.doRecentItemsSearch();
    }
    this.toggleDisplayDrawer(true);
  }

  // @ts-expect-error * Automated Type Error Fix
  handleInputFocus(event) {
    this.doItemSearch(event.target.value, false);
    this.toggleDisplayDrawer(true);
  }
  setRecentItems(newRecentItems) {
    this.recentItems = newRecentItems?.map((recentItem, index) => ({
      ...recentItem,
      recentItemId: `recent-item-${index}`
    }));
  }
  doRecentItemsSearch() {
    const recentItemsInState = selectRecentItems(recentItemStore.getState());
    if (recentItemsInState && recentItemsInState.length) {
      this.setRecentItems(recentItemsInState);
    } else {
      recentItemStore.fetchRecentItems(this.userId);
    }
  }
  doSuggestionsSearch() {
    if (this.keywordPresent()) {
      const searchSuggestionsInState = selectSearchTermSuggestions(searchTermSuggestionStore.getState(), this.keyword);
      if (searchSuggestionsInState && searchSuggestionsInState.length) {
        this.setSearchTermSuggestions(searchSuggestionsInState);
      } else {
        searchTermSuggestionStore.fetchSearchTermSuggestions(this.keyword);
      }
    }
  }
  get shouldShowSearchSuggestions() {
    return this.keywordPresent();
  }
  get shouldShowRecentItems() {
    return this.recentItems && this.recentItems.length && !this.shouldShowSearchSuggestions;
  }
  get shouldDisplayDrawer() {
    // @ts-expect-error * Automated Type Error Fix
    return this.displayDrawer && (this.shouldShowRecentItems || this.shouldShowSearchSuggestions);
  }
  get shouldDisplayDrawerStyle() {
    if (this.shouldDisplayDrawer) {
      return '';
    }
    return 'display:none';
  }
  keywordPresent() {
    return this.keyword && this.keyword.length > 0;
  }
  handleCloseIconClick() {
    this.keyword = '';
  }
  doSearch(keyword) {
    if (keyword) {
      if (keyword.trim() !== '') {
        this.keyword = keyword.trim();
        const encodedKeyword = encodeURIComponent(this.keyword);
        const url = `/appxSearchKeywordResults?keywords=${encodedKeyword}`;
        navigate(url);
      } else {
        this.keyword = '';
      }
    }
    this.toggleDisplayDrawer(false);
    this.blurInput();
  }

  // @ts-expect-error * Automated Type Error Fix
  handleSuggestionClick(event) {
    this.handleSuggestionSearch(event.currentTarget.dataset.searchValue);
  }

  // @ts-expect-error * Automated Type Error Fix
  handleSuggestionSearch(searchKeyword) {
    this.doSearch(searchKeyword);
  }

  // @ts-expect-error * Automated Type Error Fix
  handleRecentItemClick(event) {
    this.handleRecentItemSearch(event.currentTarget.dataset.searchValue);
  }

  // @ts-expect-error * Automated Type Error Fix
  handleRecentItemSearch(listingId) {
    const url = `/${Routes.LISTING}?listingId=${listingId}`;
    navigate(url);
    this.toggleDisplayDrawer(false);
    this.blurInput();
  }
  handleBackdropClick() {
    this.toggleDisplayDrawer(false);
    this.blurInput();
  }
  toggleDisplayDrawer(bool) {
    this.displayDrawer = bool;
  }
  setSearchTermSuggestions(newSearchSuggestions) {
    this.searchTermSuggestions = newSearchSuggestions?.map((suggestion, index) => ({
      ...suggestion,
      suggestionId: `suggestion-${index}`
    })) ?? [];
  }

  // @ts-expect-error * Automated Type Error Fix
  handleOptionSelected(option) {
    const searchHandlersMap = new Map([['termSuggestion', this.handleSuggestionSearch.bind(this)], ['recentItem', this.handleRecentItemSearch.bind(this)]]);
    const searchHandler = searchHandlersMap.get(option.dataset.type);
    // @ts-expect-error * Automated Type Error Fix
    searchHandler(option.dataset.searchValue);
  }
  get keywordSuggestion() {
    const suggestedKeyword = this.keyword ? this.keyword.trim() : '';
    return {
      suggestedKeyword: suggestedKeyword,
      highlighted: null,
      suggestionId: 'suggestion-keyword',
      searchKeyword: suggestedKeyword
    };
  }
  blurInput() {
    this.getInputElement()?.blur();
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(TypeAhead, {
  track: {
    searchTermSuggestions: 1,
    recentItems: 1
  },
  wire: {
    labels: {
      adapter: WireI18n,
      dynamic: [],
      config: function ($cmp) {
        return {
          selector: selectTypeAhead
        };
      }
    },
    setKeywordFromParamsAndUrl: {
      adapter: WireStore,
      dynamic: [],
      method: 1,
      config: function ($cmp) {
        return {
          store: routerStore,
          selector: state => ({
            params: selectParams(state),
            url: selectUrl(state)
          })
        };
      }
    },
    setSearchResults: {
      adapter: WireStore,
      dynamic: [],
      method: 1,
      config: function ($cmp) {
        return {
          store: searchTermSuggestionStore
        };
      }
    },
    setRecentItemsResults: {
      adapter: WireStore,
      dynamic: [],
      method: 1,
      config: function ($cmp) {
        return {
          store: recentItemStore
        };
      }
    }
  },
  fields: ["keyword", "userId", "displayDrawer", "maxSearchCharLimit"]
});
const __lwc_component_class_internal = _registerComponent(TypeAhead, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;